import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import UserSegments from '../../components/users/UserSegments';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Segments.css';

/**
 * User Segments Page Component
 * Display user segments by engagement, lifecycle, feature usage, and value
 */
const SegmentsPage = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'user-segments',
    defaultPeriod: FILTER_PERIODS.ALL
  });

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.USER_SEGMENTS.title}
        description={PAGE_INFO.USER_SEGMENTS.description}
        filters={filters}
      >
        <div className="segments-content">
          <UserSegments period={period} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default SegmentsPage;

